import { createNavigation } from 'next-intl/navigation'
import { defineRouting } from 'next-intl/routing'

export const routing = defineRouting({
	locales: ['sk'],
	// locales: ['sk', 'en'],
	defaultLocale: 'sk',
	localePrefix: 'as-needed',
	pathnames: {
		'/': '/',
		'/team': {
			en: '/team',
			sk: '/tim'
		},
		'/team/[slug]': {
			en: '/team/[slug]',
			sk: '/tim/[slug]'
		},
		'/ambulance': {
			en: '/ambulance',
			sk: '/ambulancie'
		},
		'/ambulance/[slug]': {
			en: '/ambulance/[slug]',
			sk: '/ambulancie/[slug]'
		},
		'/ambulance/[slug]/offered-services': {
			en: '/ambulance/[slug]/services',
			sk: '/ambulancie/[slug]/sluzby'
		},
		'/ambulance/[slug]/offered-services/[priceGroupSlug]': {
			en: '/ambulance/[slug]/services/[priceGroupSlug]',
			sk: '/ambulancie/[slug]/sluzby/[priceGroupSlug]'
		},
		'/contact': {
			en: '/contact',
			sk: '/kontakt'
		},
		'/blog': {
			en: '/blog',
			sk: '/clanky'
		},
		'/blog/[slug]': {
			en: '/blog/[slug]',
			sk: '/clanky/[slug]'
		},
		'/for-companies': {
			en: '/for-companies',
			sk: '/pre-firmy'
		},
		'/order': {
			en: '/order',
			sk: '/volne-terminy'
		},
		'/order/payment': {
			en: '/order/payment',
			sk: '/volne-terminy/platba'
		},
		'/annual-programs': {
			en: '/annual-programs',
			sk: '/rocne-programy'
		},
		'/annual-programs/[slug]': {
			en: '/annual-programs/[slug]',
			sk: '/rocne-programy/[slug]'
		},
		'/annual-programs/medante-vital': {
			en: '/annual-programs/medante-vital',
			sk: '/rocne-programy/medante-vital'
		},
		'/annual-programs/medante-balance': {
			en: '/annual-programs/medante-balance',
			sk: '/rocne-programy/medante-balance'
		},
		'/annual-programs/medante-solo-pediater': {
			en: '/annual-programs/medante-solo-pediater',
			sk: '/rocne-programy/medante-solo-pediater'
		},
		'/annual-programs/medante-comfort-junior': {
			en: '/annual-programs/medante-comfort-junior',
			sk: '/rocne-programy/medante-comfort-junior'
		},
		'/annual-programs/medante-platinum': {
			en: '/annual-programs/medante-platinum',
			sk: '/rocne-programy/medante-platinum'
		},
		'/annual-programs/medante-solo-gynekolog': {
			en: '/annual-programs/medante-solo-gynekolog',
			sk: '/rocne-programy/medante-solo-gynekolog'
		},
		'/medante-credit': {
			en: '/medante-credit',
			sk: '/medante-kredit'
		},
		'/preventive-examinations': {
			en: '/preventive-examinations',
			sk: '/preventivne-prehliadky'
		},
		'/preventive-examinations/[slug]': {
			en: '/preventive-examinations/[slug]',
			sk: '/preventivne-prehliadky/[slug]'
		},
		'/discounts': {
			en: '/discounts',
			sk: '/akciova-ponuka'
		},
		'/references': {
			en: '/references',
			sk: '/povedali-o-nas'
		},
		'/credit-packages': {
			en: '/credit-packages',
			sk: '/kreditne-baliky'
		},
		'/gallery': {
			en: '/gallery',
			sk: '/galeria'
		},
		'/jobs': {
			en: '/jobs',
			sk: '/kariera'
		},
		'/jobs/[slug]': {
			en: '/jobs/[slug]',
			sk: '/kariera/[slug]'
		},
		'/jobs/lets-make-world-healthier': {
			en: '/jobs/lets-make-world-healthier',
			sk: '/kariera/podte-robit-svet-zdravsim'
		},
		'/faq': {
			en: '/faq',
			sk: '/casto-kladene-otazky'
		},
		'/legal/vop': {
			en: '/general-terms-of-business',
			sk: '/vseobecne-obchodne-podmienky'
		},
		'/legal/gdpr': {
			en: '/privacy-policy',
			sk: '/ochrana-osobnych-udajov'
		},
		'/legal/marketing-consent': {
			en: '/consent-to-the-processing-of-personal-data-for-marketing-purposes',
			sk: '/suhlas-so-spracuvanim-osobnych-udajov-na-marketingove-ucely'
		},
		'/legal/cookie-policy': {
			en: '/cookie-policy',
			sk: '/zasady-pouzivania-cookies'
		},
		'/legal/consumer-contest-terms': {
			en: '/consumer-contest-terms',
			sk: '/podmienky-spotrebitelskych-sutazi'
		},
		'/thank-you': {
			en: '/thank-you',
			sk: '/dakujeme-za-objednavku'
		},
		'/thank-you/[orderId]': {
			en: '/thank-you/[orderId]',
			sk: '/dakujeme-za-objednavku/[orderId]'
		},
		'/static-pages/medante-solo-pediater': {
			en: '/medante-solo-pediatrician-limited-offer-for-the-first-100-people',
			sk: '/medante-solo-pediater-limitovana-akcia-pre-prvych-100-ludi'
		}
	}
})

export type Pathnames = keyof typeof routing.pathnames
export type Locale = (typeof routing.locales)[number]

export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing)
